import React from 'react';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Julián Méndez',
  city: 'Buenos Aires',
  quote: 'Organicé todo mi año en una tarde. Nunca más llego sin saber qué hacer. Mis alumnos notaron el cambio enseguida.',
  initials: 'JM'
}, {
  name: 'Martín Pereyra',
  city: 'Córdoba',
  quote: 'Antes perdía horas planificando y terminaba repitiendo ejercicios. Con los bonos tengo material para no aburrir nunca.',
  initials: 'MP'
}, {
  name: 'Carla Rodríguez',
  city: 'Rosario',
  quote: 'Mis alumnos mejoraron en semanas. La progresión que tiene el sistema es clave para que no se frustren.',
  initials: 'CR'
}, {
  name: 'Santiago Fernández',
  city: 'Mar del Plata',
  quote: 'Ahora manejo grupos mixtos sin caos. Las variantes por nivel me salvaron la vida en las clases de 4 personas.',
  initials: 'SF'
}, {
  name: 'Diego Iglesias',
  city: 'Mendoza',
  quote: 'Me dio la confianza para subir mis tarifas. Cuando mostrás profesionalismo y estructura, la gente paga con gusto.',
  initials: 'DI'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-[#0A1628]" data-id="element-313">
      <div className="max-w-6xl mx-auto" data-id="element-314">
        <h2 className="text-4xl md:text-5xl font-anton text-center text-white mb-16" data-id="element-315">
          Lo que dicen los instructores que ya lo usan
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-316">
          {reviews.map((review, i) => <div key={i} className="bg-[#0F1F3D] p-8 rounded-2xl border border-white/5 flex flex-col h-full" data-id="element-317">
              <div className="flex gap-1 mb-4" data-id="element-318">
                {[...Array(5)].map((_, j) => <Star key={j} className="fill-yellow-400 text-yellow-400" size={16} data-id="element-319" />)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-320">
                "{review.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-321">
                <div className="w-12 h-12 rounded-full bg-[#C6F432] text-[#0A1628] flex items-center justify-center font-black text-lg" data-id="element-322">
                  {review.initials}
                </div>
                <div data-id="element-323">
                  <p className="font-bold text-white" data-id="element-324">{review.name}</p>
                  <p className="text-sm text-gray-400" data-id="element-325">{review.city}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}